import { render, staticRenderFns } from "./XToDosList.vue?vue&type=template&id=e8d29fe2&scoped=true&"
import script from "./XToDosList.vue?vue&type=script&lang=ts&"
export * from "./XToDosList.vue?vue&type=script&lang=ts&"
import style0 from "./XToDosList.vue?vue&type=style&index=0&id=e8d29fe2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8d29fe2",
  null
  
)

export default component.exports